module.exports = __webpack_public_path__ + "img/workorder_nr3_2.bdb21c70.png";